/** @module Classes */ /** typedoc */
/**
 * @class AudioVersion
 * @summary Mastered versions of an Audio (asset) in the Library
 */
class AudioVersion {
    constructor() {
        this.albumId = null;
        this.albumName = null;
        this.canAddFormats = false;
        this.countOfFiles = 0;
        this.creationDate = null;
        this.engineMarketingVersion = null;
        this.engineVersion = null;
        this.id = null;
        this.intensity = null;
        this.isAtLeastCdAudioQuality = false;
        this.parentId = null;
        this.permissions = null;
        this.referenceId = null;
        this.referenceName = null;
        this.sharesCount = 0;
        this.state = null;
        this.style = null;
    }
}

export { AudioVersion };
